import React, { createContext, useState } from "react";
import { Toast } from "../components/common/Toast";
import DeliveryPartnerService from "../services/DeliveryPartnerService";

export const DeliveryPartnerContext = createContext("DeliveryPartnerContext");

const DeliveryPartnerContextProvider = ({ children }) => {
	const [deliveryPartnerList, setDeliveryPartnerList] = useState([]);
	const [loadingDeliveryPartnerList, setLoadingDeliveryPartnerList] =
		useState(false);
	const [deliveryPartnerListErrorMsg, setDeliveryPartnerListErrorMsg] =
		useState("");
	const [totalElements, setTotalElements] = useState(0);

	const getDeliveryPartnerList = async (params) => {
		setLoadingDeliveryPartnerList(true);
		try {
			setDeliveryPartnerListErrorMsg("");
			const response =
				await DeliveryPartnerService.getDeliveryPartnerList(params);
			setDeliveryPartnerList(response.data.content);
			setTotalElements(response.data.totalElements);
		} catch (error) {
			const message = error.response
				? error.response.data.message
					? error.response.data.message
					: error.response.data
				: error.message;
			setDeliveryPartnerListErrorMsg(message);
			Toast("error", "Error", message);
		} finally {
			setLoadingDeliveryPartnerList(false);
		}
	};

	return (
		<DeliveryPartnerContext.Provider
			value={{
				getDeliveryPartnerList,
				deliveryPartnerList,
				totalElements,
				loadingDeliveryPartnerList,
				deliveryPartnerListErrorMsg,
			}}
		>
			{children}
		</DeliveryPartnerContext.Provider>
	);
};

export default DeliveryPartnerContextProvider;
